import { render, staticRenderFns } from "./UserEditMailMiniTemplate.vue?vue&type=template&id=3c057ac1&"
import script from "./UserEditMailMiniTemplate.vue?vue&type=script&lang=js&"
export * from "./UserEditMailMiniTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports